import React from 'react';
import PropTypes from 'prop-types';

function AssetTile({
    asset = {},
    editable = false,
    deletable = false,
    legacy = false,
    editAsset = () => {},
    selectAsset = () => {},
    deleteAsset = () => {},
}) {
    // lp designs use bkgd_img or share_image for preview, envelopes use path
    const renderPreviewUrl = () => asset.bkgd_image || asset.share_image || `${asset.path}/icon.jpg` || '';
    const canDelete = () => {
        if (asset.noImage) return false; // always mark no image option as not deletable
        return !asset.selected && !asset.deleted_at && deletable;
    };
    const canEdit = () => {
        if (asset.noImage) return false; // always hide edit button on 'no image' option
        return !asset.deleted_at && editable;
    };

    return (
        <div
            className="asset-tile"
            role="button"
            aria-selected={asset.selected}
            aria-label={`Select ${asset.name}`}
            onClick={() => selectAsset(asset) }
            onKeyPress={ (e) => {
                if (e.key === 'Enter') {
                    selectAsset(asset);
                }
            }}
        >
            <div className="asset-tile__selected-frame" alt="Selected asset" role="img" style={{ display: asset.selected ? 'block' : 'none' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                    className="absolute top-0 left-0"
                >
                    <path fill="#3367F2" d="M0 50V0h50z" />
                </svg>
                <i className="fa fa-check" />
            </div>
            <div className="asset-tile__actions">
                {legacy ? <p className="asset-tile__tag">Legacy</p> : null}
                {canEdit() ? <button
                    type="button"
                    className="asset-tile__button"
                    aria-label={`Edit ${asset.name}`}
                    onClick={(e) => { e.stopPropagation(); editAsset(asset); }}
                >
                    <span className="btn__tooltip btn__tooltip--up"> Edit </span>
                    <i className="fa fa-wrench" />
                </button> : null}
                {canDelete() ? <button
                    type="button"
                    className="asset-tile__button"
                    aria-label={`Delete ${asset.name}`}
                    onClick={(e) => { e.stopPropagation(); deleteAsset(asset); }}
                >
                    <span className="btn__tooltip btn__tooltip--up"> Delete </span>
                    <i className="fa fa-trash" />
                </button> : null}
            </div>
            <div className="asset-tile__preview" style={{ backgroundImage: 'url(' + renderPreviewUrl() + ')' }}>
                {asset.noImage ? <i className="fa fa-ban font-size-48px font-gray-90" /> : null}
            </div>
            <p className="asset-tile__name">{asset.name}</p>
        </div>
    );
}

AssetTile.propTypes = {
    asset: PropTypes.shape({
        name: PropTypes.string,
        noImage: PropTypes.bool,
        selected: PropTypes.bool,
        bkgd_image: PropTypes.string,
        share_image: PropTypes.string,
        path: PropTypes.string,
        deleted_at: PropTypes.string,
    }).isRequired,
    editable: PropTypes.bool,
    deletable: PropTypes.bool,
    legacy: PropTypes.bool,
    editAsset: PropTypes.func,
    selectAsset: PropTypes.func,
    deleteAsset: PropTypes.func,
};

export default AssetTile;
